import { type EventConfig, type EventConfigInput, type RedtailEventConfig } from '../../../models/Scheduling'

export interface RedtailOption {
  id: string
  label: string
}

export const REDTAIL_UNSET = ''
export const REDTAIL_NOT_CONFIGURED_LABEL = 'Not configured'

export const toRedtailSelection = (id?: number): string => (id === undefined ? REDTAIL_UNSET : id.toString())

export const redtailSelectValue = (id: string, options: RedtailOption[]): string => (options.some((option) => option.id === id) ? id : REDTAIL_UNSET)

export const isPartialRedtailSelection = (activityCodeId: string, categoryId: string): boolean => Boolean(activityCodeId) !== Boolean(categoryId)

export const toRedtailEventConfig = (activityCodeId: string, categoryId: string): RedtailEventConfig | null =>
  activityCodeId && categoryId ? { activityCodeId: Number(activityCodeId), categoryId: Number(categoryId) } : null

export const ownRedtailEntry = (config: EventConfig | null | undefined, redtailAccountId: string): RedtailEventConfig | undefined =>
  config?.redtail?.[redtailAccountId]

export const isSameRedtailEntry = (a?: RedtailEventConfig, b?: RedtailEventConfig): boolean =>
  a?.activityCodeId === b?.activityCodeId && a?.categoryId === b?.categoryId

export const withOwnRedtailEntry = (config: EventConfig | null | undefined, redtailAccountId: string, entry: RedtailEventConfig | null): EventConfig | null => {
  if (entry) {
    return { redtail: { ...config?.redtail, [redtailAccountId]: entry } }
  }
  const redtail = config?.redtail
  if (!redtail || !(redtailAccountId in redtail)) {
    return config ?? null
  }
  const remaining = Object.fromEntries(Object.entries(redtail).filter(([key]) => key !== redtailAccountId))
  return Object.keys(remaining).length > 0 ? { redtail: remaining } : null
}

export const toEventConfigInput = (config: EventConfig | null | undefined, redtailAccountId: string): EventConfigInput => ({
  redtail: ownRedtailEntry(config, redtailAccountId) ?? null,
})
